import styled from 'styled-components';
import { Button } from '../index';
import { colors } from '../../assets/variables';
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #d7f1ff;
  border-radius: 10px;
  padding: 28px;
  margin-bottom: 16px;
  min-height: 240px;
`;
const Rating = styled.div`
  display: flex;
  max-width: 250px;
  margin: 8px 0;
`;

const Star = styled.div`
  cursor: pointer;
  padding: 0 5px;
  flex: 1;
`;
const Error = styled.div`
  color: red;
  font-size: 0.8em;
  margin-bottom: 16px;
`;

const ReviewBox = styled.textarea`
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 124px;
  resize: none;
  padding: 10px 16px 24px 16px;
  border: 1px solid rgba(11, 38, 65, 1);
  border-radius: 7px;
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
`;
const CtaWrap = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
const Box = styled.div`
  background: #abe4fe;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75px;
  height: 75px;
  margin-bottom: 24px;
  padding: 18px;
`;

const ButtonNew = styled(Button)`
  border-radius: 30px;
  background: white;
  color: ${colors.primary};
  border: 1px solid ${colors.primary};
  text-transform: none;
  height: 46px;
  padding: 0px 32px;
  font-size: 14px;
`;
export default {
  Wrap,
  Star,
  Rating,
  ReviewBox,
  CtaWrap,
  Error,
  Box,
  ButtonNew,
};
